import { ConditionRegistryItem } from '../../../registry/condition/ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
import { ChoiceOptionState } from '../../../classes/learnware/LearnwareEnums';
export class ConditionsChoiceOptionUI extends ConditionRegistryCategory {
    label = 'Option UI';
    constructor(parent) {
        super(parent);
        super.init();
    }
    optionstate_CorrectDone = () => new ConditionRegistryItem({
        parent: this,
        label: 'OptionState CorrectDone',
        eval: ({ option }) => !!option && option.optionUI.choiceOptionUIState === ChoiceOptionState.CorrectDone
    });
    optionstate_CorrectPending = () => new ConditionRegistryItem({
        parent: this,
        label: 'OptionState CorrectPending',
        eval: ({ option }) => !!option && option.optionUI.choiceOptionUIState === ChoiceOptionState.CorrectPending
    });
    optionstate_Wrong = () => new ConditionRegistryItem({
        parent: this,
        label: 'OptionState Wrong',
        eval: ({ option }) => !!option && option.optionUI.choiceOptionUIState === ChoiceOptionState.Wrong
    });
    optionstate_ShouldHaveBeenSelected = () => new ConditionRegistryItem({
        parent: this,
        label: 'OptionState ShouldHaveBeenSelected',
        eval: ({ option }) => !!option && option.optionUI.choiceOptionUIState === ChoiceOptionState.ShouldHaveBeenSelected
    });
    optionstate_Default = () => new ConditionRegistryItem({
        parent: this,
        label: 'OptionState Default',
        eval: ({ option }) => !!option && option.optionUI.choiceOptionUIState === ChoiceOptionState.Default
    });
    optionstate_Correct = () => new ConditionRegistryItem({
        parent: this,
        label: 'OptionState CorrectDone or CorrectPending',
        eval: ({ option }) => !!option &&
            [ChoiceOptionState.CorrectDone, ChoiceOptionState.CorrectPending].includes(option.optionUI.choiceOptionUIState)
    });
    optionstate_Correct2 = () => new ConditionRegistryItem({
        parent: this,
        label: 'OptionState CorrectDone, CorrectPending or ShouldHaveBeenSelected',
        eval: ({ option }) => !!option && option.optionUI.shouldOptionBeGreen
    });
    optionstate_Correct3 = () => new ConditionRegistryItem({
        parent: this,
        label: 'OptionState CorrectDone or ShouldHaveBeenSelected',
        eval: ({ option }) => !!option &&
            [ChoiceOptionState.CorrectDone, ChoiceOptionState.ShouldHaveBeenSelected].includes(option.optionUI.choiceOptionUIState)
    });
    option_preselecting = () => new ConditionRegistryItem({
        parent: this,
        label: 'Antwortoption VORausgewählt',
        eval: ({ option }) => !!option && option.isPreselecting
    });
    option_shouldShowTemporaryFalseFeedback = () => new ConditionRegistryItem({
        parent: this,
        label: 'shouldShowTemporaryFalseFeedback',
        eval: ({ option }) => {
            if (!option)
                return false;
            return option.optionUI.shouldShowTemporaryFalseFeedback(1500);
        }
    });
    option_shouldShowTemporaryCorrectFeedback = () => new ConditionRegistryItem({
        parent: this,
        label: 'shouldShowTemporaryCorrectFeedback',
        eval: ({ option }) => {
            if (!option)
                return false;
            return option.optionUI.shouldShowTemporaryCorrectFeedback(500);
        }
    });
    option_isHoverSoundPlaying = () => new ConditionRegistryItem({
        parent: this,
        label: 'Is Hoversound Playing',
        eval: ({ option }) => !!option && option.optionAudio.isHoverAudioPlaying
    });
}
